import {RevisionItemCategory} from "./RevisionItemCategory";

export const RevisionItemCategoryColors: Record<RevisionItemCategory, "info" | "success" > = {
  [RevisionItemCategory.BASIC]: "info",
  [RevisionItemCategory.SPECIFIC]: "success",
};
